"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const i18n_1 = tslib_1.__importDefault(require("./plugins/i18n"));
const App_vue_1 = tslib_1.__importDefault(require("./App.vue"));
const router_1 = tslib_1.__importDefault(require("./router"));
const Layout_vue_1 = tslib_1.__importDefault(require("./layout/Layout.vue"));
const app = (0, vue_1.createApp)(App_vue_1.default);
app.config.globalProperties.$filters = {};
app.use(router_1.default);
app.use(i18n_1.default);
app.component('Layout', Layout_vue_1.default);
app.provide('$router', router_1.default);
app.provide('$filters', app.config.globalProperties.$filters);
app.mount('#app');
